import { notifyIcon, requestMethod } from "../../config";
import config from "../../env.config";
import { checkApiSuccess } from "../../utils";
import { getNotification } from "../../utils/common";
import { fetch } from "./api.service";

const WORKFLOW_EMAIL_URL = `${config.BASE_URL.BASE_API_URL}/email`;
const WORKFLOW_EMAIL_URL_PROJECT = `${config.BASE_URL.BASE_API_URL}/workflow`;

/**
 * api to get all the email details
 *  @author Sarthak Arora
 */
export const getAllEmailDetails = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getAllEmailDetails`,
      params: {
        searchText: data?.searchText,
        limit: data?.limit,
        offset: data?.offset,
        projectId: data?.projectId,
        searchFilter: data?.searchFilter,
        companyId: data?.companyId,
        isSpam: data?.isSpam && 1,
        workflowId: data?.workflowId?.join(","),
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};

/**
 * api to get all the email details
 *  @author Sarthak Arora
 */
export const getAllEmailReplies = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getAllEmailReplies`,
      params: {
        searchText: data?.searchText,
        limit: data?.limit,
        offset: data?.offset,
        projectId: data?.projectId,
        searchFilter: data?.searchFilter,
        companyId: data?.companyId,
        workflowId: data?.workflowId?.join(","),
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};
/**
 * api to get all the email details
 */
export const getAllEmailDraftDetails = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getAllEmailDraftDetails`,
      params: {
        limit: data?.limit,
        offset: data?.offset,
        workflowId: data?.workflowId?.join(","),
        projectId: data?.projectId,
        companyId: data?.companyId,
        searchFilter: data?.searchFilter,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};

/**
 * api to delete email details
 *  @author Sejal
 */
export const getTrashEmails = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getTrashEmailDetails`,
      params: {
        limit: data?.limit,
        offset: data?.offset,
        projectId: data?.projectId,
        searchFilter: data?.searchFilter,
        workflowId: data?.workflowId?.join(","),
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};

/**
 * api to update email details
 *  @author Sejal
 */
export const restoreEmail = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_EMAIL_URL}/restoreEmail`,
      data: payload,
    };
    let response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    }
  };
};

/**
 * api to update email details
 *  @author Sejal
 */
export const updateEmailDetails = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_EMAIL_URL}/updateEmailDetails`,
      data: payload,
    };
    let response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    }
  };
};

/**
 * api to update email details
 *  @author Sejal
 */
export const updateEmailReply = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_EMAIL_URL}/updateEmailReply`,
      data: payload,
    };
    let response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    }
  };
};

/**
 * api to get all the workflow details
 *  @author Sejal
 */
export const getWorkflowsThroughProjectId = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL_PROJECT}/GetWorkflowsThroughProjectId`,
      params: {
        projectId: data?.projectId,
        userId: data?.userId,
      },
    };
    let response = await fetch(requestConfig, false, true);
    if (checkApiSuccess(response)) {
      return response?.data.data;
    }
  };
};

/**
 * api to get all the workflow details
 *  @author Sejal
 */
export const getWorkflowsThroughUserId = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL_PROJECT}/GetWorkflowsThroughUserId`,
      params: {
        userId: data?.userId,
      },
    };
    let response = await fetch(requestConfig, false, true);
    if (checkApiSuccess(response)) {
      return response?.data.data;
    }
  };
};

/**
 * api to get the email details of a particular email
 *  @author Sarthak Arora
 */

export const getEmailDetails = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getEmailDetails`,
      params: {
        emailThreadId: payload.emailThreadId,
        next: payload?.next,
        previous: payload?.previous,
        projectId: payload?.projectId,
        isSpam: payload?.isSpam,
        isTrash: payload?.isTrash,
        searchFilter: payload?.searchFilter,
        workflowId: payload?.workflowId,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};

/**
 * api to get the email details of a particular email
 *
 */
export const getEmailDraftDetails = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getEmailDraftDetails`,
      params: {
        emailDraftId: payload?.emailDraftId,
        next: payload?.next,
        previous: payload?.previous,
        projectId: payload?.projectId,
        workflowId: payload?.workflowId,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};

/**
 * api to get the email details of a particular email
 *  @author Sarthak Arora
 */

export const getEmailReplyDetails = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getEmailReplyDetails`,
      params: {
        emailReplyId: payload.emailReplyId,
        next: payload?.next,
        previous: payload?.previous,
        projectId: payload?.projectId,
        searchFilter: payload?.searchFilter,
        workflowId: payload?.workflowId,
        emailType: payload?.emailType,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};
/*
 **
 * api to get the email details of a particular email in task sidebar
 *  @author Sejal
 */

export const GetEmailDetailsByTask = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/GetEmailDetailsByTask`,
      params: {
        emailThreadId: payload.emailThreadId,
        next: payload?.next,
        emailType: payload?.emailType,
        previous: payload?.previous,
        taskId: payload?.taskId,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails;
    }
  };
};

/**
 * api to delte a particular email
 *  @author Sarthak Arora
 */
export const deleteEmail = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_EMAIL_URL}/deleteEmail`,
      data: payload,
    },
    response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * api to delte a particular email
 *  @author Sarthak Arora
 */
export const deleteEmailReply = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_EMAIL_URL}/deleteEmailReply`,
      data: payload,
    },
    response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};
/**
 * api to get details of all the spam emails
 *  @author Sarthak Arora
 */
export const getAllSpamEmailDetails = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getAllSpamEmailDetails`,
      params: {
        searchText: data?.searchText,
        limit: data?.limit,
        offset: data?.offset,
        companyId: data?.companyId,
      },
    };
    let response = await fetch(requestConfig, false, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.spamEmailDetails;
    }
  };
};

/**
 * api to add spam emails
 *  @author Sarthak Arora
 */
export const addSpamDetails = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_EMAIL_URL}/addSpamDetails`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data;
    }
  };
};

/**
 * api to delete spam emails
 *  @author Sarthak Arora
 */
export const deleteSpamDetails = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_EMAIL_URL}/deleteSpamDetails`,
      data: {
        spamId: payload?.spamId,
        userId: payload?.userId,
        emailId: payload?.emailId,
        projectId: payload?.projectId,
        companyId: null,
        emailThreadId: payload?.emailThreadId,
      },
    },
    response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * api to pdate checkbox in inbox
 *  @author Sejal
 */
export const addWorkflowDisplayHistory = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_EMAIL_URL_PROJECT}/addWorkflowDisplayHistory`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response?.data;
    }
  };
};

/**
 * api to get all emails for a specific task
 * @author Sejal
 */
export const getAllEmailsForTask = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL}/getAllEmailsForTask`,
      params: {
        limit: data?.limit,
        offset: data?.offset,
        taskId: data?.taskId,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data?.emailDetails || [];
    }
    return [];
  };
};

/**
 * handling api for adding draft email
 * @param {data}
 * @returns {void}
 */

export const addEmailDraft = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/email/addEmailDraft`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
  };
};

/**
 * api to delete draft emails
 */
export const deleteEmailDraft = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_EMAIL_URL}/deleteEmailDraft`,
      data: payload,
    },
    response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

/**
 * api to get all emails for a specific task
 * @author Sejal
 */
export const getWorkflowEmails = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_EMAIL_URL_PROJECT}/getWorkflowEmails`,
      params: {
        workflowId: payload?.workflowId,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    }
    return [];
  };
};

/**
 * handling api for adding draft email
 * @param {data}
 * @returns {void}
 */

export const updateEmailDraft = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${config.BASE_URL.BASE_API_URL}/email/updateEmailDraft`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
  };
};

/**
 * handling api for sending email
 * @param {data}
 * @returns {void}
 */
export const sendEmailReply = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/email/sendEmailReply`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
  };
};

/**
 * handling api for creating task from email
 * @param {data}
 * @returns {void}
 * @author Sejal
 */
export const createTaskFromEmail = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/email/createTaskFromEmail`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
  };
};
